import { kea } from 'kea'
import PropTypes from 'prop-types'

export default kea({
  initScene: {
    scene: 'pagesContact',

    transform: payload => ({
      showLegal: payload.showLegal
    })
  },

  path: () => ['scenes', 'pagesContact', 'index'],

  reducers: () => ({
    showLegal: [true, PropTypes.bool, {}]
  })
})
